import { useState } from "react";

import ChunkUploadFile from "components/ChunkUploadFile";
import UploadItem from "features/main/Loads/modules/UploadItem";
import { UploadedFile } from "models/Component";
import { UPLOAD_DOCUMENT_URLS } from "constants/routes";
import { NEW_CARRIER_CATEGORY } from "constants/base";

interface INoaAttach {
  paymentProfileId: string;
  purpose: "bank" | "noa";
}

export default function NOAAttach({ paymentProfileId, purpose }: Readonly<INoaAttach>) {
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const category =
    NEW_CARRIER_CATEGORY.find(
      (option) => option.value === (purpose === "noa" ? "noa" : "voided_check")
    ) ?? NEW_CARRIER_CATEGORY[0];

  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-col items-center">
        <span>Please attach:</span>
        <span className="text-xs font-thin">
          {purpose === "noa"
            ? "Carrier’s Notice of Assignment (NOA)"
            : "Voided Check or Direct Deposit Slip"}
        </span>
      </div>

      <ChunkUploadFile
        categories={[category]}
        defaultCategory={category}
        disableCategorySelection
        className="mt-4 desktop:flex desktop:flex-col desktop:gap-4 desktop:text-lg"
        urlCallback={
          UPLOAD_DOCUMENT_URLS({
            payment_profile_id: paymentProfileId
          }).NEW_CARRIER
        }
        onUploadFinished={(files: any) => {
          const noaAttachFiles: UploadedFile[] = files.map((file: any) => ({
            name: file.name,
            size: file.fileSize,
            type: file.fileType,
            fileType: Array.isArray(file.categories)
              ? file.categories
              : String(file.categories || category.label).split(","),
            url: file.preview_url
          }));
          setUploadedFiles((currentFiles) => [...currentFiles, ...noaAttachFiles]);
        }}
      />
      {uploadedFiles.map((file) => (
        <div key={file.name} className="-mx-2">
          <UploadItem file={file} />
        </div>
      ))}
    </div>
  );
}
